var studentMixin = {
  methods: {
    getGroups() {
      let groups = [
        { id: 107, name: 'Year 7' },
        { id: 108, name: 'Year 8' },
        { id: 109, name: 'Year 9' },
        { id: 110, name: 'Year 10' },
        { id: 111, name: 'Year 11' },
        { id: 112, name: 'Year 12' },
        { id: 212, name: 'Ex Year 12' },
        { id: 300, name: 'Exited Students' },
      ];

      return groups;
    },
  },
};

export default studentMixin;
